import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input, CustomInput, FormFeedback, InputGroupAddon, InputGroupText, InputGroup } from 'reactstrap';
import api from '~/services/api';
import Loader from '~/components/Loader/Loader'

function ModalEdit({ coupon, showModal, toggle, loadCoupons }) {
  const [code, setCode] = useState('');
  const [description, setDescription] = useState('');
  const [vindiPlanIds, setVindiPlanIds] = useState('');
  const [type, setType] = useState('MONETARY');
  const [value, setValue] = useState('');
  const [usageLimit, setUsageLimit] = useState('');
  const [quantityPaymentsApplicable, setQuantityPaymentsApplicable] = useState('');
  const [restrictedEmails, setRestrictedEmails] = useState('');
  const [active, setActive] = useState(true);
  const [emptyCode, setEmptyCode] = useState(false)
  const [modalDelete, setModalDelete] = useState(false)
  const [loading, setLoading] = useState(false)
  const [deleteLoading, setDeleteLoading] = useState(false)
  const [allowPix, setAllowPix] = useState(true);

  useEffect(() => {
    setCode(coupon.code)
    setDescription(coupon.description || '')
    setVindiPlanIds(coupon.vindi_plan_ids || '')
    setType(coupon.type)
    setValue(coupon.value)
    setUsageLimit(coupon.usage_limit || '')
    setQuantityPaymentsApplicable(coupon.quantity_payments_applicable || '')
    setRestrictedEmails(coupon.restricted_emails || '')
    setActive(coupon.active === 1 ? true : false)
    setAllowPix(coupon.allow_pix === 1 ? true : false)
  }, [coupon])

  async function handleSubmit() {
    try {
      setLoading(true)

      const data = {
        code: code,
        description: description,
        vindi_plan_ids: vindiPlanIds,
        type: type,
        value: parseFloat(value),
        usage_limit: parseInt(usageLimit),
        quantity_payments_applicable: parseInt(quantityPaymentsApplicable),
        restricted_emails: restrictedEmails,
        active: active,
        allow_pix: allowPix,
      }

      if (!data.code) setEmptyCode(true)

      if (!data.code) {
        setLoading(false)
        return
      }

      await api.put(`coupons/${coupon.id}`, data)

      setEmptyCode(false)

      setLoading(false)

      toast.success('Cupom atualizado com sucesso')

      loadCoupons(1)
    } catch (error) {
      setLoading(false)
      if (error.response.data?.message === 'coupon_duplicate_plan_code') {
        toast.error('Código já cadastrado com mesmo id de Plano')
      } else {
        toast.error('Ocorreu um erro ao atualizar o cupom')
      }
    }
  }

  async function handleDelete() {
    try {
      setDeleteLoading(true)

      await api.delete(`coupons/${coupon.id}`)

      setDeleteLoading(false)

      toast.success('Cupom apagado com sucesso')

      setModalDelete(prev => !prev)
      toggle()

      loadCoupons(1)
    } catch (error) {
      setDeleteLoading(false)
      toast.error('Ocorreu um erro ao apagar o cupom')
    }
  }

  return (
    <div>
      <Modal isOpen={modalDelete} toggle={() => setModalDelete(prev => !prev)}>
        <ModalHeader toggle={() => setModalDelete(prev => !prev)}>Apagar cupom #{coupon.id}</ModalHeader>
        <ModalBody>
          {deleteLoading && <Loader />}
          Tem certeza?
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setModalDelete(prev => !prev)}>Não</Button>{' '}
          <Button color="danger" onClick={handleDelete}>Sim</Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={showModal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Editar cupom de desconto #{coupon.id}</ModalHeader>
        <ModalBody>
          {loading && <Loader />}
          <Form>
            <FormGroup>
              <Label for="code">Digite o código</Label>
              <Input type="text" name="code" id="code" value={code} onChange={e => setCode(e.target.value.trim().toUpperCase())} invalid={emptyCode} />
              <FormFeedback>Código é obrigatório</FormFeedback>
            </FormGroup>
            <FormGroup>
              <Label for="description">Descrição do cupom (Apenas para informações internas)</Label>
              <Input type="textarea" name="description" id="description" value={description} onChange={e => setDescription(e.target.value)} />
            </FormGroup>
            <FormGroup>
              <Label for="vindi_plan_ids">Códigos dos planos da Vindi aplicáveis (Separar por vírgula*. Deixe em branco para aplicar a qualquer pagamento)</Label>
              <Input type="text" name="vindi_plan_ids" id="vindi_plan_ids" value={vindiPlanIds} onChange={e => setVindiPlanIds(e.target.value.trim())} />
            </FormGroup>
            <FormGroup>
              <Label for="type">Tipo de cupom</Label>
              <Input type="select" name="type" id="type" value={type} onChange={e => setType(e.target.value)}>
                <option value="MONETARY">Monetário</option>
                <option value="PERCENTAGE">Percentual</option>
              </Input>
            </FormGroup>
            <FormGroup>
              <Label for="value">Valor do cupom (O cupom percentual pode chegar a até 100%, para casos de cortesias)</Label>
              <InputGroup>
                <Input type="number" name="value" id="value" value={value} onChange={e => setValue(e.target.value)} />
                <InputGroupAddon addonType="append">
                  <InputGroupText>{type === 'MONETARY' ? 'R$' : '%'}</InputGroupText>
                </InputGroupAddon>
              </InputGroup>
            </FormGroup>
            <FormGroup>
              <Label for="usage_limit">Limite de uso</Label>
              <Input type="number" name="usage_limit" id="usage_limit" value={usageLimit} onChange={e => setUsageLimit(e.target.value)} />
            </FormGroup>
            <FormGroup>
              <Label for="quantity_payments_applicable">Aplicável a quantos pagamentos (Deixe em branco para aplicar em todos os pagamentos da assinatura)</Label>
              <Input type="number" name="quantity_payments_applicable" id="quantity_payments_applicable" value={quantityPaymentsApplicable} onChange={e => setQuantityPaymentsApplicable(e.target.value)} />
            </FormGroup>
            <FormGroup>
              <Label for="restricted_emails">Restrição por e-mail? (Separar por vírgula*. Deixe em branco para não restringir o uso)</Label>
              <Input type="textarea" name="restricted_emails" id="restricted_emails" value={restrictedEmails} onChange={e => setRestrictedEmails(e.target.value.trim())} />
            </FormGroup>
            <FormGroup>
              <CustomInput type="switch" id="active" name="active" label="Cupom ativo?" checked={active} onChange={() => setActive(prev => !prev)} />
            </FormGroup>
            <FormGroup>
              <CustomInput type="switch" id="allow_pix" name="allow_pix" label="Permite pix?" checked={allowPix} onChange={() => setAllowPix(prev => !prev)} />
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>Cancelar</Button>{' '}
          <Button color="danger" onClick={() => setModalDelete(prev => !prev)}>Apagar</Button>{' '}
          <Button color="primary" onClick={handleSubmit}>Salvar</Button>
        </ModalFooter>
      </Modal>
    </div>
  )
}

export default ModalEdit;